'use strict';

const attendance_slugs = {
    going: 'going',
    interested: 'interested',
    checkedin: 'checked_in'
};

export { attendance_slugs as ATTENDANCE_SLUGS };
